import Container from 'react-bootstrap/esm/Container';
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'

const BottomBar = () => {
  return (
    <>
      {/* <div className='footer' style={{ backgroudColor: 'red' }}> */}
      <div className='footer' >
        <div className='blank'></div>
        <Navbar className="px-1 mt-4" expand="md" bg="success bg-opacity-25" variant="light" style={{ position: "sticky" }} fixed='bottom'>
          <Container>
            <Nav className="mr-auto mt-1" justify-content-center='true'>
              <Nav style={{ alignItems: "center" }}><small>関連リンク</small></Nav>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Nav.Link href={"https://www.bosai.go.jp/"}><small>防災科学技術研究所</small></Nav.Link>
              <Nav.Link href={"https://e-defense.bosai.go.jp/"}><small>Ｅ－ディフェンス</small></Nav.Link>
              <Nav.Link href={"https://e-simulator.bosai.go.jp/"}><small>数値震動台研究開発プロジェクト</small></Nav.Link>
              {/* {createAccountLink} */}
              {/* {viewerLink} */}
              {/* {changePasswordLink} */}
            </Nav>
            <Nav>
              <div>
                <small>
                  <small>
                    Copyright © 国立研究開発法人防災科学技術研究所
                  </small>
                </small>
              </div>
            </Nav>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default BottomBar;